.base {
	position: relative;
	display: flex;
	flex-direction: column;
	flex: 1;
	min-width: 0;
	height: 100%;
	background: var(--parrot-chat-bg);
}

.list {
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	/* Extra bottom padding so the last message is never hidden behind the floating composer. */
	padding: 20px 20px 120px;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

/* Floats the composer over the message list. Spans from just below the header to the
   bottom so fullscreen-compose can grow up to the top; pointer-events pass through the
   empty area and the scrim to the messages underneath. */
.composerDock {
	position: absolute;
	left: 0;
	right: 0;
	top: var(--parrot-chat-header-height);
	bottom: 0;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	padding: 0 16px 14px;
	pointer-events: none;
}

.scrim {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	height: 132px;
	background: linear-gradient(to top, var(--parrot-chat-composer-scrim) 52%, transparent);
	pointer-events: none;
}
